<template>
  <motlet :options="motletOptions" dense>
    <template v-slot:content="{ props }">
      <!-- eslint-disable-next-line prettier/prettier -->
      <field-selectable-grid
        :sstmId="props.motlet.descendant.systemId"
        :code="props.motlet.settings.grid.code"
        :event-code="props.motlet.settings.grid.eventCode"
        :selected="props.motlet.settings.grid.selectedFields"
        :click-row="clickRow"
        :height="params.height"
        :store-name="storeName"
        :timestamp="timestamp"
        first-row-selected
        row-selected-emit-name="select:log"
      />
    </template>
  </motlet>
</template>

<script>
import bus from '@/utils/bus';
import FieldSelectableGrid from '../../../components/java/FieldSelectableGrid';

export default {
  components: {
    FieldSelectableGrid,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
    storeName: String,
    timestamp: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      motletOptions: {
        id: 'detailview/java/javaLog/logGrid',
        title: 'Log List',
        settings: { grid: { use: true, code: 'G_JAVA_LOG', eventCode: 'JAVA_LOG' } },
        descendant: {
          systemId: this.params.sstmId,
        },
      },
    };
  },
  methods: {
    clickRow(item, { isSelected, select }) {
      select(!isSelected);
      bus.$emit('select:log', item);
    },
  },
};
</script>
